// extracted by mini-css-extract-plugin
export default {"endorsers":"index_endorsers__zlmc5","iframe":"index_iframe__PxpC9"};